/**
 * @author: sunc
 * @create: 2019/12/27 4:04 下午
 * @version: 1.0
 * @email: sunc@oceansoft.com
 */

export class Source {

  static getSource() {
    let u = navigator.userAgent.toLowerCase();//获取判断用的对象
    let logSource = "PC";
    if (u.match(/MicroMessenger/i) == "micromessenger") {
      logSource = "WEI";
    } else if (u.indexOf('iphone') > -1 && u.match(/AlipayClient/i) == "alipayclient") {
      //是否在IOS浏览器打开
      logSource = "ALIPAY";
    } else if (u.indexOf('iphone') > -1) {
      //是否在IOS浏览器打开
      logSource = "IOS";
    } else if (u.match(/AlipayClient/i) == "alipayclient" && u.indexOf('android') > -1) {
      //是否在支付宝
      logSource = "ALIPAY";
    }  else if (u.match(/AlipayClient/i) == "alipayclient" && u.indexOf('linux') > -1) {
      //是否在支付宝
      logSource = "ALIPAY";
    } else if (u.indexOf('android') > -1 || u.indexOf('linux') > -1) {
      //是否在安卓浏览器打开
      logSource = "ANDROID";
    }
    return logSource;
  }

}

